import { get } from '../axios';
import config from './config';

const { API_PREFIX } = config;

export default {
  /**
   * get possible roles for client
   *
   * @param {String} clientId
   * @returns {Promise}
   */
  getRoles(clientId) {
    const URL = `${API_PREFIX}/${clientId}/roles`;
    return new Promise((resolve, reject) => {
      get(URL)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  },
};
